import { useAuthContext } from '../../context';
import { useEffect } from 'react';
import { useProfile } from '../../context/ProfileContext';
import { Navigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';


interface IAuthGuardProps {
    children: React.ReactNode;
}

export const AuthGuard = ({ children }: IAuthGuardProps): JSX.Element | null => {
    const { handleRefreshToken, accessToken, isAuthenticated } = useAuthContext();
    const { isPermissionInitialized, hasPermissionLoadError, retryLoadPermissions } = useProfile();

    useEffect(() => {

        if (!accessToken) {
            handleRefreshToken();
        }

    }, [accessToken]);

    if (!isPermissionInitialized) return null;

    if (!isAuthenticated) {
        return (
            <Navigate to='/login'></Navigate>
        );
    }

    // /me/permissions falhou: `permissions` está null e todo gate responderia "não pode".
    // Deixar a aplicação montar assim entrega um sistema visualmente vazio, sem explicação —
    // era indistinguível de perda de permissão e não se recuperava sem F5.
    if (hasPermissionLoadError) {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh" gap={2} px={3} textAlign="center">
                <Typography variant="h6">Não foi possível carregar suas permissões</Typography>
                <Typography variant="body2" color="text.secondary" maxWidth={480}>
                    Isto é uma falha de comunicação, não uma alteração no seu perfil. Tente novamente; se
                    persistir, contate o suporte técnico.
                </Typography>
                <Button variant="contained" onClick={retryLoadPermissions}>
                    Tentar novamente
                </Button>
            </Box>
        );
    }

    return (
        <>
            {children}
        </>
    )
}
